import consumer from './consumer';

let salesTeamSubscription = null;

export function subscribeTo(salesTeamId) {
  if (salesTeamSubscription) {
    salesTeamSubscription.unsubscribe();
  }

  salesTeamSubscription = consumer.subscriptions.create(
    { channel: 'SalesTeamChannel', sales_team_id: salesTeamId },
    {
      received(data) {
        if (data.type === 'activity') {
          const feed = document.getElementById('sales-team-feed');
          if (feed) {
            feed.insertAdjacentHTML('beforeend', data.html);
            feed.scrollTop = feed.scrollHeight;
          }
        }

        if (data.type === 'email_card') {
          const emailCards = document.getElementById('sales-email-cards');
          if (emailCards) {
            const emptyState = emailCards.querySelector('.review-empty');
            if (emptyState) emptyState.remove();
            emailCards.insertAdjacentHTML('afterbegin', data.html);

            // Pulse the count badge
            const badge = document.getElementById('email-count-badge');
            if (badge) {
              const count = emailCards.querySelectorAll('.email-card').length;
              badge.textContent = count;
              badge.style.display = '';
              badge.classList.remove('email-count-pulse');
              // Force reflow so the animation restarts
              void badge.offsetWidth;
              badge.classList.add('email-count-pulse');
            }
          }
        }

        if (data.type === 'play_card') {
          const playQueue = document.getElementById('play-queue');
          if (playQueue) {
            const emptyState = playQueue.querySelector('.play-queue-empty');
            if (emptyState) emptyState.remove();
            // Insert before the completed-plays section, or at the end
            const completed = playQueue.querySelector('.completed-plays-toggle');
            if (completed) {
              completed.insertAdjacentHTML('beforebegin', data.html);
            } else {
              playQueue.insertAdjacentHTML('beforeend', data.html);
            }
          }
        }

        if (data.type === 'play_queue') {
          const playQueue = document.getElementById('play-queue');
          if (playQueue) {
            playQueue.outerHTML = data.html;
          }
        }

        if (data.type === 'team_status') {
          document.dispatchEvent(
            new CustomEvent('sales-team:status', { detail: data })
          );
        }

        if (data.type === 'pending_count') {
          // Sidebar badge — updates from any page the user is on.
          const navBadge = document.getElementById('sales-team-nav-badge');
          if (navBadge) {
            navBadge.textContent = data.count;
            navBadge.hidden = data.count === 0;
          }
        }
      }
    }
  );

  return salesTeamSubscription;
}

export default { subscribeTo };
